const getFileName = (file) => {
  return file.replace(/(.*\/)*([^.]+).*/gi, '$2');
};
const getFileExp = (file) => {
  const index = file.lastIndexOf('.');
  return file.substr(index + 1);
};
const isImg = (type) => {
  const imgs = [
    'image/png',
    'image/jpeg',
    'image/gif',
    'jpg',
    'png',
    'gif',
    'jpeg',
    'jfif',
  ];
  return imgs.some((img) => img === type);
};
const isAudio = (type) => {
  const audios = ['audio/mpeg', 'audio/wav', 'mp3', 'wav', 'wma', 'flac'];
  return audios.some((au) => au === type);
};

const isVideo = (type) => {
  const vides = ['video/mp4', 'video/mpeg', 'mp4', 'avi', 'mov', 'flv', '3gp'];
  return vides.some((v) => v === type);
};
const getFileType = (type) => {
  let t = 'file';
  if (isImg(type)) {
    t = 'img';
    return t;
  }
  if (isAudio(type)) {
    t = 'audio';
    return t;
  }
  if (isVideo(type)) {
    t = 'video';
    return t;
  }
  return t;
};
const getFileSize = (value) => {
  const s = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
  const e = Math.floor(Math.log(value) / Math.log(1024));
  return (value / Math.pow(1024, Math.floor(e))).toFixed(2) + ' ' + s[e];
};
export {
  getFileName,
  getFileExp,
  isImg,
  isAudio,
  isVideo,
  getFileType,
  getFileSize,
};
